module.exports = __webpack_public_path__ + "static/media/success.3fe03b3b.svg";